import { useRef } from "react";
import { Table } from "../shared";

export const JobItemsTable = ({
  tableData,
  columns,
  job,
  meta,
  globalSearchFilters,
  ...props
}) => {
  const tableRef = useRef(null);

  return (
    <Table
      ref={tableRef}
      data={tableData}
      columns={columns}
      meta={{
        job,
        ...(meta || {}),
      }}
      hideCheckbox
      rowClickExpand
      getRowCanExpand={() => true}
      {...props}
    />
  );
};
